import { Routes } from '@angular/router';
import { RouteLocations } from './common/routing/route-locations.enum';
import { LoggedInRouteGuard } from './common/routing/route-guards/logged-in.guard';
import { FeaturePermissionsRouteGuard, FeaturePermissionsRouteGuardData } from './common/routing/route-guards/feature-permissions.guard';
import { FeaturePermission } from '../../../common/model/feature-permissions.enum';
import {
  DeletedAccountRequestRouteGuard,
} from './common/routing/route-guards/account-deletion.guard';

export const routes: Routes = [
  {
    path: RouteLocations.Dashboard.relativeUrl,
    loadChildren: () => import('./dashboard/dashboard.module').then(_ => _.DashboardModule),
    canActivate: [
      LoggedInRouteGuard,
      DeletedAccountRequestRouteGuard,
      FeaturePermissionsRouteGuard,
    ],
    data: {
      requiredFeaturePermissions: [
        FeaturePermission.Feature_Dashboard,
      ],
    } satisfies FeaturePermissionsRouteGuardData,
  },
  {
    path: RouteLocations.ParentConsent.relativeUrl,
    loadComponent: () => import('./parent-consent/parent-consent.component').then(_ => _.ParentConsentComponent),
  },
  {
    path: RouteLocations.SubscriptionRequired.relativeUrl,
    loadComponent: () => import('./subscription-required/subscription-required.component').then(_ => _.SubscriptionRequiredComponent),
  },
  {
    path: RouteLocations.NotFound.relativeUrl,
    loadComponent: () => import('./not-found/not-found.component').then(_ => _.NotFoundComponent),
  },
  {
    path: RouteLocations.Authentication.relativeUrl,
    loadChildren: () => import('./authentication/authentication.module').then(_ => _.AuthenticationModule)
  },
  {
    path: RouteLocations.DeleteSchedule.relativeUrl,
    loadChildren: () => import('./delete-schedule/delete-schedule.module').then(_ => _.DeleteScheduleModule),
  },
  {
    path: '**',
    loadComponent: () => import('./wild-card-redirect.component').then(_ => _.WildCardRedirectComponent)

  }
];
